import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useRef, useEffect } from 'react';
import { Modal } from '../../../../Modal';
import { ImageCrop } from '../../../../ImageCrop';
import { usePrefixCls } from '../../../../../config/hooks/usePrefixCls';
import { Success } from '@tencent/adp-icons-react';
import classNames from 'classnames';
import { Button } from '../../../../Button';
import { useCropResultList } from '../hooks';
import { ImageItem } from '../ImageItem';
var getButtonText = function getButtonText(selectedIndex, value, result) {
  var isFirst = selectedIndex === 0;
  var isLast = value.length === selectedIndex + 1;
  var currentImage = value[selectedIndex];
  var ok = {
    text: '确认',
    action: 'confirm',
    visibility: true
  };
  var cancel = {
    text: '取消',
    action: 'cancel',
    visibility: true
  };
  if (!isLast) {
    ok.action = 'next';
    ok.text = '下一张';
  }
  if (!isFirst) {
    cancel.action = 'previous';
    cancel.text = '上一张';
  }
  if (result.length === value.length) {
    ok.action = 'finish';
    ok.text = '完成';
  }
  if (isLast && result.length < value.length) {
    if (isImageCropped(currentImage, result)) {
      ok.visibility = false;
    } else {
      ok.action = 'confirm';
      ok.text = '确认';
    }
  }
  return [ok, cancel];
};
var Footer = function Footer(props) {
  var _props$okText = props.okText,
    okText = _props$okText === void 0 ? '确认' : _props$okText,
    _props$cancelText = props.cancelText,
    cancelText = _props$cancelText === void 0 ? '取消' : _props$cancelText,
    _props$showCancel = props.showCancel,
    showCancel = _props$showCancel === void 0 ? true : _props$showCancel,
    _props$showOK = props.showOK,
    showOK = _props$showOK === void 0 ? true : _props$showOK,
    onCancel = props.onCancel,
    onOK = props.onOK;
  return React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '16px 24px'
    }
  }, showCancel && React.createElement(Button, {
    onClick: onCancel
  }, cancelText), showOK && React.createElement(Button, {
    style: {
      marginLeft: 10
    },
    type: 'primary',
    onClick: onOK
  }, okText));
};
var isImageCropped = function isImageCropped(image, result) {
  if (result.length === 0) {
    return false;
  }
  var isExisted = result.find(function (item) {
    return item.value.materialId === image.materialId;
  });
  return !!isExisted;
};
var setImageCropped = function setImageCropped(image, data, result) {
  var newResult = _toConsumableArray(result);
  if (!isImageCropped(image, result) && data) {
    newResult.push({
      value: image,
      cropInfo: data
    });
  }
  return newResult;
};
var getSelectedCropSize = function getSelectedCropSize(result) {
  var _a;
  if (result.length === 0) {
    return null;
  }
  return ((_a = result[0].cropInfo) === null || _a === void 0 ? void 0 : _a.targetSize) || null;
};
var getFinalResult = function getFinalResult(data) {
  var newData = data.map(function (item) {
    var cropInfo = item.cropInfo;
    if (!cropInfo) {
      return item;
    }
    var croppedAreaPixels = cropInfo.croppedAreaPixels;
    var newPixels = _objectSpread(_objectSpread({}, croppedAreaPixels), {}, {
      x: croppedAreaPixels.x + Math.random() * 5,
      y: croppedAreaPixels.y + Math.random() * 5
    });
    return _objectSpread(_objectSpread({}, item), {}, {
      cropInfo: _objectSpread(_objectSpread({}, item.cropInfo), {}, {
        croppedAreaPixels: newPixels
      })
    });
  });
  return newData;
};
export var CropSizeDialog = function CropSizeDialog(props) {
  var visible = props.visible,
    value = props.value,
    _props$cropSizeConfig = props.cropSizeConfig,
    cropSizeConfig = _props$cropSizeConfig === void 0 ? [] : _props$cropSizeConfig,
    onCancel = props.onCancel,
    onOk = props.onOk;
  var _useCropResultList = useCropResultList(),
    _useCropResultList2 = _slicedToArray(_useCropResultList, 2),
    state = _useCropResultList2[0],
    setState = _useCropResultList2[1];
  var selectedIndex = state.selectedIndex,
    result = state.result;
  var selectedImage = value[selectedIndex];
  var cls = usePrefixCls('material-library-multiple-crop-dialog');
  var ref = useRef();
  var cropImageListRef = useRef(null);
  var selectedCropSize = getSelectedCropSize(result);
  var disableCropSizeConfig = !selectedCropSize ? [] : cropSizeConfig.filter(function (item) {
    return item.maxHeight !== (selectedCropSize === null || selectedCropSize === void 0 ? void 0 : selectedCropSize.maxHeight) || item.maxWidth !== (selectedCropSize === null || selectedCropSize === void 0 ? void 0 : selectedCropSize.maxWidth) || item.minHeight !== (selectedCropSize === null || selectedCropSize === void 0 ? void 0 : selectedCropSize.minHeight) || item.minWidth !== (selectedCropSize === null || selectedCropSize === void 0 ? void 0 : selectedCropSize.minWidth);
  });
  var onCropComplete = function onCropComplete(croppedAreaPixels, targetSize) {
    console.log(croppedAreaPixels, targetSize);
    ref.current = {
      croppedAreaPixels: _objectSpread(_objectSpread({}, croppedAreaPixels), {}, {
        x: croppedAreaPixels.x + Math.random() * 5,
        y: croppedAreaPixels.y + Math.random() * 5
      }),
      targetSize: targetSize
    };
  };
  var _getButtonText = getButtonText(selectedIndex, value, result),
    _getButtonText2 = _slicedToArray(_getButtonText, 2),
    ok = _getButtonText2[0],
    cancel = _getButtonText2[1];
  var handleOk = function handleOk() {
    if (ok.action === 'finish') {
      setState({
        result: [],
        selectedIndex: 0
      });
      return onOk(getFinalResult(result));
    }
    var newResult = setImageCropped(selectedImage, ref.current, result);
    var index = ok.action === 'next' ? selectedIndex + 1 : selectedIndex;
    setState({
      result: newResult,
      selectedIndex: index
    });
  };
  var handleCancel = function handleCancel() {
    if (cancel.action === 'cancel') {
      return closeDialog();
    }
    var newResult = setImageCropped(selectedImage, ref.current, result);
    setState({
      result: newResult,
      selectedIndex: selectedIndex - 1
    });
  };
  var closeDialog = function closeDialog() {
    setState({
      result: [],
      selectedIndex: 0
    });
    onCancel();
  };
  var scrollToSelectedImage = function scrollToSelectedImage(selectedImage) {
    if (!selectedImage || !(cropImageListRef === null || cropImageListRef === void 0 ? void 0 : cropImageListRef.current)) {
      return;
    }
    var materialId = selectedImage.materialId;
    var dom = document.getElementById(materialId);
    if (dom) {
      cropImageListRef.current.scrollTop = dom.offsetTop - dom.clientHeight * 2 - 32;
    }
  };
  useEffect(function () {
    scrollToSelectedImage(selectedImage);
  }, [selectedImage]);
  return React.createElement(Modal, {
    show: visible,
    title: '图片裁剪',
    onCancel: closeDialog,
    footer: React.createElement(Footer, {
      okText: ok.text,
      cancelText: cancel.text,
      onOK: handleOk,
      onCancel: handleCancel,
      showOK: ok.visibility,
      showCancel: cancel.visibility
    })
  }, React.createElement("div", {
    className: 'description'
  }, "\u68C0\u6D4B\u5230\u4E0A\u4F20\u7684\u56FE\u7247\u683C\u5F0F\u5927\u5C0F\u4E0D\u7B26\u5408\u89C4\u8303\uFF0C\u53EF\u8FDB\u884C\u88C1\u526A\u540E\u8FDB\u884C\u6295\u653E"), React.createElement("div", {
    className: cls
  }, React.createElement("div", {
    className: 'list',
    ref: cropImageListRef
  }, value.map(function (image, index) {
    return React.createElement("div", {
      id: image.materialId,
      key: index,
      onClick: function onClick() {
        return setState({
          selectedIndex: index
        });
      },
      className: classNames('item', {
        selected: index === selectedIndex
      })
    }, isImageCropped(image, result) && React.createElement(Success, {
      className: 'success',
      fill: "#22de51",
      size: 20
    }), React.createElement(ImageItem, {
      value: image
    }));
  })), visible && selectedImage && React.createElement(ImageCrop, {
    image: {
      url: selectedImage.imageUrl,
      width: selectedImage.imageWidth,
      height: selectedImage.imageHeight,
      name: selectedImage.description
    },
    cropSizeConfig: cropSizeConfig,
    showDescription: false,
    onCropComplete: onCropComplete,
    labelType: 'ratio',
    disableCropSizeConfig: disableCropSizeConfig
  })));
};